export const isHippocrates = window.location.host.includes('hippocrates');
export const isAsprofosvit = window.location.host.includes('asprofosvit');

export const siteUrl = isHippocrates
  ? `${process.env.REACT_APP_HIPPOCRATES_URL}`
  : `${process.env.REACT_APP_ASPROFOSVIT_URL}`;

export const siteLoginUrl = `${siteUrl}/login`;
